import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ah4p50x0: FaireBrandEntity = {
  token: "b_ah4p50x0",
  type: "brand",
  name: "L'ovedbaby",
  avatarUrl:
    "https://cdn.faire.com/fastly/c444f2c75286b360ea4280fcc7c1d4558bfd26cd6ccdf0cdb331e2c90aeecacc.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fd8ff7d96e99668eeb929a6f7d4b1c7a09b8a96b199b67c7e4f547d515c90ff7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c444f2c75286b360ea4280fcc7c1d4558bfd26cd6ccdf0cdb331e2c90aeecacc.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fd8ff7d96e99668eeb929a6f7d4b1c7a09b8a96b199b67c7e4f547d515c90ff7.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 13,
  isTopShop: true,
  isInsider: true,
  description:
    "L'ovedbaby creates baby clothing that embodies comfort, safety, and environmental stewardship. Using GOTS-certified organic cotton, our garments are free from harmful chemicals, protecting delicate skin and the planet. As a family-owned business, we support boutique retailers with versatile, timeless collections that align with slow fashion values. By partnering with L'ovedbaby, you join a movement promoting ethical production and sustainable choices for a better future.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:16.178Z",
    importedBy: "entity-db-cli",
  },
};
